var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var StandoffSpacerGeneratorInteractionModel = require('./standoffSpacerGeneratorInteractionModel.js');

var MaleFemaleStandoffSpacerGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;
    StandoffSpacerGeneratorInteractionModel.apply(this, arguments);

    this.postLength = this.shadow("postLength",
        function() {
            return self.data.postLength() / self.getUnitFactor();
        },
        function(value) {
            return self.data.postLength(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.postLength, self.userSettingsModel.distanceUnit
        ]
    );

    this.postThreadType = this.shadow("postThreadType",
        function() {
            return self.data.postThreadType();
        },
        function(value) {
            return self.data.postThreadType(value);
        },
        [
            self.data.postThreadType
        ]
    );

    this.postThreadSize = this.shadow("postThreadSize",
        function() {
            return self.data.postThreadSize();
        },
        function(value) {
            return self.data.postThreadSize(value);
        },
        [
            self.data.postThreadSize
        ]
    );

    this.postThreadDesignation = this.shadow("postThreadDesignation",
        function() {
            return self.data.postThreadDesignation();
        },
        function(value) {
            return self.data.postThreadDesignation(value);
        },
        [
            self.data.postThreadDesignation
        ]
    );

    this.innerThreadDepth = this.shadow("innerThreadDepth",
        function() {
            return self.data.innerThreadDepth() / self.getUnitFactor();
        },
        function(value) {
            return self.data.innerThreadDepth(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.innerThreadDepth, self.userSettingsModel.distanceUnit
        ]
    );

    this.innerThreadType = this.shadow("innerThreadType",
        function() {
            return self.data.innerThreadType();
        },
        function(value) {
            return self.data.innerThreadType(value);
        },
        [
            self.data.innerThreadType
        ]
    );

    this.innerThreadSize = this.shadow("innerThreadSize",
        function() {
            return self.data.innerThreadSize();
        },
        function(value) {
            return self.data.innerThreadSize(value);
        },
        [
            self.data.innerThreadSize
        ]
    );

    this.innerThreadDesignation = this.shadow("innerThreadDesignation",
        function() {
            return self.data.innerThreadDesignation();
        },
        function(value) {
            return self.data.innerThreadDesignation(value);
        },
        [
            self.data.innerThreadDesignation
        ]
    );

    //////////////////////////////////////////////
    //////////////// Inner Thread ////////////////
    //////////////////////////////////////////////
    
    this.innerThreadSizeList = this.value("innerThreadSizeList", true);
    this.innerThreadDesignationList = this.value("innerThreadDesignationList", true);
    this.initializeThreadInfo(this.data.innerThreadType, this.data.innerThreadSize, this.data.innerThreadDesignation, this.innerThreadSizeList, this.innerThreadDesignationList);

    //////////////////////////////////////////////
    //////////////// Post Thread ////////////////
    //////////////////////////////////////////////
    
    this.postThreadSizeList = this.value("postThreadSizeList", true);
    this.postThreadDesignationList = this.value("postThreadDesignationList", true);
    this.initializeThreadInfo(this.data.postThreadType, this.data.postThreadSize, this.data.postThreadDesignation, this.postThreadSizeList, this.postThreadDesignationList);
};

lib_core.inherit(MaleFemaleStandoffSpacerGeneratorInteractionModel, StandoffSpacerGeneratorInteractionModel);
StandoffSpacerGeneratorInteractionModel.$class = 'MaleFemaleStandoffSpacerGeneratorInteractionModel';
module.exports = MaleFemaleStandoffSpacerGeneratorInteractionModel;

MaleFemaleStandoffSpacerGeneratorInteractionModel.prototype.getInspectorElementForPost = function() {
    var postLength = PackageGeneratorInspectorConfig.getValueFixedUnit('L1', this.LCLZ('postLength', 'Post Length'), this.postLength, this.userSettingsModel.distanceUnit);

    //var postThreadType = PackageGeneratorInspectorConfig.getSelectbox('Post Thread Type', this.postThreadType, this.getThreadTypes());
    var postThreadSize = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('postThreadSize', 'Post Thread Size'), this.postThreadSize, this.postThreadSizeList);
    var postThreadDesignation = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('postThreadDesignation', 'Post Thread Designation'), this.postThreadDesignation, this.postThreadDesignationList, this.hasThread);

    return [postLength, /*postThreadType, */postThreadSize, postThreadDesignation];
};

MaleFemaleStandoffSpacerGeneratorInteractionModel.prototype.getInspectorElementForInnerThreading = function() {
    var innerThreadDepth = PackageGeneratorInspectorConfig.getValueFixedUnit('L', this.LCLZ('innerThreadDepth', 'Inner Thread Depth'), this.innerThreadDepth, this.userSettingsModel.distanceUnit);

    //var innerThreadType = PackageGeneratorInspectorConfig.getSelectbox('Inner Thread Type', this.innerThreadType, this.getThreadTypes());
    var innerThreadSize = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('innerThreadSize', 'Inner Thread Size'), this.innerThreadSize, this.innerThreadSizeList);
    var innerThreadDesignation = PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('innerThreadDesignation', 'Inner Thread Designation'), this.innerThreadDesignation, this.innerThreadDesignationList, this.hasThread);

    return [innerThreadDepth, /*innerThreadType, */innerThreadSize, innerThreadDesignation];
};

MaleFemaleStandoffSpacerGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = StandoffSpacerGeneratorInteractionModel.prototype.getInspectorElements.call(this).input_elements;

    imElements.unshift(this.getInspectorElementForLabel(this.LCLZ('maleFemaleStandoffNote', '* Mounting hole pad is optional and can be generated by entering values for dimensions shown in the left image. Hole diameter (b) is used for mounting hole generation.'))[0]);
    imElements = imElements.concat(this.getInspectorElementForInnerThreading());
    imElements = imElements.concat(this.getInspectorElementForPost());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
